<div class="gradient-tool">
  <!-- Gradient preview -->
  <div class="gradient-preview" [ngStyle]="gradientPreviewStyle()"></div>

  <!-- Two-column layout -->
  <div class="columns-layout">
    <!-- Column 1: Color stops -->
    <div class="colors-column">
      <label class="column-label">{{ "widgets.color-picker.gradient.color-stops" | translate }}</label>

      @for (stop of colorStops(); track $index) {
        <div class="color-stop-row">
          <div class="color-stop-swatch" [style.backgroundColor]="stop.color" (click)="openColorPickerDialog($index)" [matTooltip]="stop.color"></div>

          <mat-form-field class="position-field" appearance="outline">
            <input
              matInput
              type="number"
              [min]="0"
              [max]="100"
              [ngModel]="stop.position"
              (ngModelChange)="updateStopPosition($index, $event)"
              aria-label="Color stop position" />
            <span matSuffix>%</span>
          </mat-form-field>

          @if (canRemoveStop()) {
            <mat-icon class="remove-stop" (click)="removeStop($index)" [matTooltip]="'widgets.color-picker.gradient.remove-stop' | translate">close</mat-icon>
          }
        </div>
      }

      @if (canAddStop()) {
        <button class="add-stop-btn" (click)="addStop()">
          <mat-icon>add</mat-icon>
          {{ "widgets.color-picker.gradient.add-stop" | translate }}
        </button>
      }
    </div>

    <!-- Divider -->
    <div class="column-divider"></div>

    <!-- Column 2: Settings -->
    <div class="angle-column">
      @if (gradientType() === "linear") {
        <label class="column-label">{{ "widgets.color-picker.gradient.angle" | translate }}</label>
        <mat-form-field class="angle-field" appearance="outline">
          <input matInput type="number" [min]="0" [max]="360" [ngModel]="angle()" (ngModelChange)="updateAngle($event)" aria-label="Gradient angle" />
          <span matSuffix>°</span>
        </mat-form-field>
      }

      <label class="column-label">{{ "widgets.color-picker.gradient.type" | translate }}</label>
      <div class="type-toggle">
        <button
          class="type-btn"
          [class.active]="gradientType() === 'linear'"
          (click)="setGradientType('linear')"
          [matTooltip]="'widgets.color-picker.gradient.linear' | translate">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect x="1" y="1" width="14" height="14" rx="2" stroke="currentColor" stroke-width="1.2" />
            <line x1="3" y1="13" x2="13" y2="3" stroke="currentColor" stroke-width="1.4" />
            <polygon points="13,3 9,4 12,7" fill="currentColor" />
          </svg>
        </button>
        <button
          class="type-btn"
          [class.active]="gradientType() === 'radial'"
          (click)="setGradientType('radial')"
          [matTooltip]="'widgets.color-picker.gradient.radial' | translate">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.2" />
            <circle cx="8" cy="8" r="4.5" stroke="currentColor" stroke-width="1" />
            <circle cx="8" cy="8" r="2" fill="currentColor" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Apply button -->
  <button class="apply-btn" (click)="applyGradient()" [disabled]="!isGradientChanged()">
    {{ "widgets.color-picker.gradient.apply" | translate }}
  </button>
</div>
